module.exports = __webpack_public_path__ + "static/img/2.1ccfdff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/2.jpg
// module id = skK/
// module chunks = 1